import { ICase } from '@/utils/types/ICaseBattle';
import CaseSkin from '@/components/CaseBattles/CaseSkin';

interface Props {
    items: ICase['items'];
}

const CaseModal = ({ items }: Props) => {
    const sorted = [...items].sort((a, b) => b.item.priceUsd - a.item.priceUsd);

    return (
        <div className="flex flex-col gap-3 min-h-0">
            <div className="flex items-center justify-between">
                <span className="text-[11px] uppercase tracking-[0.10em] text-text_4 font-bold">
                    Drops{' '}
                    <b className="font-chat-nick text-[#5fe0ff] font-extrabold ml-1 tabular-nums">
                        {items.length}
                    </b>
                </span>
                <span className="text-[11px] text-text_3">
                    Hover an item for full name
                </span>
            </div>
            <div className="fluent-scrollbar overflow-y-auto pr-1.5 [scrollbar-gutter:stable] max-h-[460px] max-md:max-h-[60vh]">
                <div className="grid gap-2 [grid-template-columns:repeat(auto-fill,minmax(124px,1fr))]">
                    {sorted.map((item) => (
                        <CaseSkin key={item.id} item={item} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CaseModal;
